import { NumericalOperationType } from './numerical-operation-type';
var NumericalOperationHelper = /** @class */ (function () {
    function NumericalOperationHelper() {
    }
    NumericalOperationHelper.getProportionalConversionSettings = function () {
        return {
            type: NumericalOperationType.ProportionalConversion,
            settings: {
                upperLimit: '',
                lowerLimit: ''
            }
        };
    };
    NumericalOperationHelper.getZoomSettings = function () {
        return {
            type: NumericalOperationType.Zoom,
            settings: {
                gain: '',
                offset: ''
            }
        };
    };
    return NumericalOperationHelper;
}());
export { NumericalOperationHelper };
